import { api } from "./api"

export interface BasicFilter{

}

export const THEMES_BY_POSITION = async (params: BasicFilter) => {
    const {data} = await api.get("/statistics/themes/by/position", { params })
    return data || [];
}

export const THEMES_BY_PRIORITY = async (params: BasicFilter) => {
    const {data} = await api.get("/statistics/themes/by/priority", { params })
    return data || [];
}
